import React from "react"

const NoHeaderLayout = ({ children }) => {
  return <main>{children}</main>
}

export default NoHeaderLayout
